"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _util = _interopRequireDefault(require("util"));

var _Term = _interopRequireDefault(require("../Term"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GroupedTerms = /*#__PURE__*/function () {
  function GroupedTerms(key, term) {
    this.key = key;
    this.terms = term ? [term] : [];
  }

  var _proto = GroupedTerms.prototype;

  _proto.push = function push(item, empty) {
    var _this = this;

    if (item instanceof GroupedTerms) {
      this.push([item], empty);
    } else if (Array.isArray(item)) {
      item.forEach(function (gt) {
        _this.terms = _this.terms.concat(gt.terms);
        if (empty) gt.terms = [];
      });
    } else {
      throw new Error("strange item pushed to GroupedTerms " + item);
    }
  };

  return GroupedTerms;
}();
/**
 * this clusters nodes bby a characteristic, returnedd
 * by the test fn. Unlike lodash groupBy it works
 * in series, not in aggregate; i.e., it compares the outyput
 * to the output of the last node in a series not the
 * whole collection. ;
 * @param series
 * @param test
 */


var groupBy = function groupBy(series, test) {
  if (!Array.isArray(series)) {
    throw new Error("groupBy requires arrays or terms that have array values only");
  }
  /*
   iterate through the values, returning arrays of sets
    */


  return series.reduce(function (memo, term) {
    var lastTerm = (0, _lodash.last)(memo);
    var key = test(term, memo, lastTerm);

    if (!memo.length) {
      return [new GroupedTerms(key, term)];
    } // If current term is a new "turn", even if same speaker, create new GroupedTerms


    if (term.meta === "turn") {
      memo.push(new GroupedTerms(key, term));
    } // If last and current speaker for term is the same, append to last term
    else if (lastTerm.key === key) {
      lastTerm.terms.push(term);
    } else {
      memo.push(new GroupedTerms(key, term));
    }

    return memo;
  }, []);
};

var _default = groupBy;
exports["default"] = _default;